import React, { useState, useRef, useContext } from "react";
import { Col, Dropdown, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Form from "../form/Form";
import "./navigation.css";
import Modal from "../modal/Modal";
import { CartContext } from "../../contexts/CartContext";
import CartProductCard from "../cartProductCard/CartProductCard";
import Button from "../button/Button";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import { ENDPOINT, getJWT, getOutletSessionId } from "../../helpers/Helper";
import DropDown from "../dropdown/DropDown";
import { CategoryContext } from "../../contexts/CategoryContext";
import { ServicesContext } from "../../contexts/ServicesContext";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FavouriteContext } from "../../contexts/FavouriteContext";

const clickOutsideRef = (content_ref, toggle_ref) => {
  document.addEventListener("mousedown", (e) => {
    // user click toogle
    if (toggle_ref.current && toggle_ref.current.contains(e.target)) {
      content_ref.current.classList.toggle("active");
    } else {
      // user click outside toggle and content
      if (content_ref.current && !content_ref.current.contains(e.target)) {
        content_ref.current.classList.remove("active");
      }
    }
  });
};

const renderLoading = () => <Spinner animation="border" variant="light" />;

const renderSearchForm = (item, index) => (
  <React.Fragment key={index}>
    <div className="input">
      <input
        required
        type={item.type}
        placeholder={item.placeholder}
        value={item.stateValue}
        onChange={item.onChange}
      />
    </div>
  </React.Fragment>
);

const renderSignInForm = (item, index, handleShowPassword) => (
  <React.Fragment key={index}>
    <div className="input-black">
      <input
        required
        type={item.type}
        placeholder={item.placeholder}
        value={item.value}
        onChange={item.onChange}
      />
      {item.password ? (
        <React.Fragment>
          {item.type === "password" ? (
            <i
              class="bx bxs-show"
              onClick={handleShowPassword}
              style={{ cursor: "pointer", marginLeft: "1rem" }}
            ></i>
          ) : (
            <i
              class="bx bxs-low-vision"
              onClick={handleShowPassword}
              style={{ cursor: "pointer", marginLeft: "1rem" }}
            ></i>
          )}
        </React.Fragment>
      ) : null}
    </div>
  </React.Fragment>
);

const renderSignUpForm = (item, index) => (
  <React.Fragment key={index}>
    <div className="input-black">
      <input
        required
        type={item.type}
        placeholder={item.placeholder}
        value={item.value}
        onChange={item.onChange}
      />
    </div>
  </React.Fragment>
);

// const renderForgotPasswordForm = (item, index) => {
//     <React.Fragment key={index}>
//         <div className='input-black'>
//             <input
//                 required
//                 type={item.type}
//                 placeholder={item.placeholder}
//                 value={item.value}
//                 onChange={item.onChange}
//             />
//         </div>
//     </React.Fragment>
// }

const renderSignInModal = (
  signInputData,
  handleSignUpModal,
  handleForgotPasswordModal,
  submitSignIn,
  loading,
  handleShowPassword
) => {
  const socialIcons = [
    {
      icon: "bx bxl-google",
      targetLink: "",
    },
    {
      icon: "bx bxl-facebook-circle",
      targetLink: "",
    },
  ];
  return (
    <div>
      {/* Sign In Form */}
      <h6>Welcome Back! Sign In to continue shopping with us</h6>
      <Form
        flexForm={false}
        formInputData={signInputData}
        renderForm={(item, index) =>
          renderSignInForm(item, index, handleShowPassword)
        }
        buttonContent={loading ? renderLoading() : "Sign In"}
        buttonColor="main-bg"
        buttonContentColor="white"
        borderRadius="all"
        auth={true}
        handleForgotPasswordBtn={handleForgotPasswordModal}
        handleForm={submitSignIn}
      />

      <span className="remember__forgotPass">
        <a href="#" onClick={handleSignUpModal}>
          Do not have an account? Create one
        </a>
      </span>
    </div>
  );
};

const renderSignUpModal = (
  signUpInputData,
  handleSignInModal,
  submitSignUp,
  loading
) => {
  const socialIcons = [
    {
      icon: "bx bxl-google",
      targetLink: "",
    },
    {
      icon: "bx bxl-facebook-circle",
      targetLink: "",
    },
  ];
  return (
    <div>
      <h6>Welcome! Sign Up to continue shopping with us</h6>
      <Form
        flexForm={false}
        formInputData={signUpInputData}
        renderForm={(item, index) => renderSignUpForm(item, index)}
        buttonContent={loading ? renderLoading() : "Sign Up"}
        buttonColor="main-bg"
        buttonContentColor="white"
        borderRadius="all"
        handleForm={submitSignUp}
      />

      <span className="remember__forgotPass">
        <a href="#" onClick={handleSignInModal}>
          Already have an account? Sign In
        </a>
      </span>
    </div>
  );
};

const renderForgotPasswordModal = (
  forgotPasswordInputData,
  handleSignInModal,
  submitForgotPassword,
  loading
) => (
  <>
    <h6>
      Forgot Password? Please input your email address used to register for an
      account
    </h6>
    <Form
      flexForm={false}
      formInputData={forgotPasswordInputData}
      renderForm={(item, index) => renderSignInForm(item, index)}
      buttonContent={loading ? renderLoading() : "Submit"}
      buttonColor="main-bg"
      buttonContentColor="white"
      borderRadius="all"
      handleForm={submitForgotPassword}
    />

    <span className="remember__forgotPass">
      <a href="#" onClick={handleSignInModal}>
        Sign In
      </a>
    </span>
  </>
);

const renderSuccessfulForgotPasswordSubmitionModal = (
  forgotPasswordInputData,
  handleSignInModal,
  submitForgotPassword,
  loading
) => (
  <>
    <h6>
      Your reset password request has been successfully recieved. A reset
      password link has been set to your email address.
    </h6>
  </>
);

const renderSuccessfulSignUp = () => (
  <div className="successful_signup">
    <div className="successful_signup-logo">
      <img src="https://res.cloudinary.com/emacon-production/image/upload/v1638363592/the-outlet/Artboard_7_copy_3png_cyyl9i.png" />
    </div>
    <div className="successful_signup-message">
      <p>
        Thank you for coming onboard, please check your email for a verification
        link.
      </p>
    </div>
  </div>
);

const renderUserToggle = (userData) => (
  <div className="topnav__rigth-user">
    <i class="bx bxs-user-circle" style={{ marginRight: "0.5rem" }}></i>
    <div className="topnav__rigth-user-name">
      {userData.name !== null ? userData.name : userData.email}
    </div>
    <i class="bx bx-chevron-down"></i>
  </div>
);

const user_menu = [
  {
    icon: "bx bx-cart",
    content: "Product Orders",
    targetLink: "/orders",
  },
  {
    icon: "bx bxs-group",
    content: "Service Orders",
    targetLink: "/service-bookings",
  },
  {
    icon: "bx bx-user",
    content: "Profile",
    targetLink: "/profile",
  },
  {
    icon: "bx bx-log-out-circle bx-rotate-180",
    content: "Logout",
    targetLink: "#",
  },
];

const renderUserMenu = (item, index, handleLogOut) => (
  <Link
    className="submenu-item"
    to={item.targetLink}
    key={index}
    onClick={item.content === "Logout" ? handleLogOut : ""}
  >
    <i className={item.icon}></i>
    <span>{item.content}</span>
  </Link>
);

const renderLoadingButton = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="light" />
  </div>
);

function Navigation(props) {
  const navigate = useNavigate();

  const { products, cartId, triggerReload } = useContext(CartContext);

  let total = 0;

  if (products) {
    for (const item of products) {
      total += item.price * item.quantity;
    }
  }

  const { services } = useContext(ServicesContext);

  const {
    authState,
    authType,
    userData,
    handleLogOut,
    showAuthModal,
    handleShowAuthModal,
    handleOnCloseAuthModal,
    handleSignInModal,
    handleSignUpModal,
    handleForgotPasswordModal,
    handleSuccessfulSignUpModal,
    handleSuccessfulForgotPasswordModal,
  } = useContext(AuthContext);
  const { categories } = useContext(CategoryContext);

  const { favouritesData, triggerFavouritesReload } =
    useContext(FavouriteContext);

  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingFav, setLoadingFav] = useState(false);

  const [searchProduct, setSearchProduct] = useState();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [yearOfBirth, setYearOfBirth] = useState();

  const [openLiquorStore, setOpenLiqourStore] = useState(false);
  const [openServices, setOpenServices] = useState(false);

  const menu_ref = useRef(null);
  const menu_toggle_ref = useRef(null);

  clickOutsideRef(menu_ref, menu_toggle_ref);

  const setActiveMenu = () => menu_ref.current.classList.add("active");
  const closeMenu = () => menu_ref.current.classList.remove("active");

  const favourite_ref = useRef(null);
  const favourite_toggle_ref = useRef(null);

  clickOutsideRef(favourite_ref, favourite_toggle_ref);

  const setActiveFavourite = () =>
    favourite_ref.current.classList.add("active");
  const closeFavourite = () => favourite_ref.current.classList.remove("active");

  const mobileMenu_ref = useRef(null);
  const mobileMenu_toggle_ref = useRef(null);

  clickOutsideRef(mobileMenu_ref, mobileMenu_toggle_ref);

  const setActiveMobileMenu = () =>
    mobileMenu_ref.current.classList.add("active");
  const closeMobileMenu = () =>
    mobileMenu_ref.current.classList.remove("active");

  const searchInputData = [
    {
      type: "text",
      placeholder: "Search....",
      value: searchProduct,
      onChange: (e) => setSearchProduct(e.target.value),
    },
  ];

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const signInInputData = [
    {
      type: "text",
      placeholder: "Email",
      value: email,
      onChange: (e) => setEmail(e.target.value),
      password: false,
    },
    {
      type: showPassword ? "text" : "password",
      placeholder: "Password",
      value: password,
      onChange: (e) => setPassword(e.target.value),
      password: true,
    },
  ];

  const signUpInputData = [
    {
      type: "text",
      placeholder: "Name",
      value: name,
      onChange: (e) => setName(e.target.value),
    },
    {
      type: "text",
      placeholder: "Email Address",
      value: email,
      onChange: (e) => setEmail(e.target.value),
    },
    {
      type: "text",
      placeholder: "Phone Number",
      value: phone,
      onChange: (e) => setPhone(e.target.value),
    },
    {
      type: "password",
      placeholder: "Password",
      value: password,
      onChange: (e) => setPassword(e.target.value),
    },
    {
      type: "text",
      placeholder: `Birth year, to verify if you're 18+ `,
      value: yearOfBirth,
      onChange: (e) => setYearOfBirth(e.target.value),
    },
  ];

  const forgotPasswordInputData = [
    {
      type: "text",
      placeholder: "Email Address",
      value: email,
      onChange: (e) => setEmail(e.target.value),
    },
  ];

  const submitSignUp = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${ENDPOINT}/auth/register`, {
        name: name,
        email: email,
        phone: phone,
        password: password,
      })
      .then((res) => {
        handleSuccessfulSignUpModal();
        setLoading(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoading(false);
      });
  };

  const submitSignIn = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${ENDPOINT}/auth/login`, {
        email: email,
        password: password,
      })
      .then((res) => {
        localStorage.setItem("JWT_TOKEN_OUTLET", res.data.token);
        handleOnCloseAuthModal();
        setLoading(false);
        toast("Welcome back!", {
          type: "success",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });

        if ((cartId && cartId !== null) || undefined) {
          axios
            .put(
              `${ENDPOINT}/cart/merge-cart`,
              { cartId: cartId && cartId },
              {
                headers: {
                  Authorization: `Bearer ${getJWT()}`,
                  sessionId: getOutletSessionId(),
                },
              }
            )
            .then((res) => {})
            .catch((err) => {
              toast(`Oops! ${err.response.data.error}`, {
                type: "error",
                position: "top-right",
                autoClose: "1000",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
              });
            });
        }
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoading(false);
      });
  };

  const submitForgotPassword = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${ENDPOINT}/auth/forgot-password`, { email: email })
      .then((res) => {
        setLoading(false);
        handleSuccessfulForgotPasswordModal();
      })
      .catch((err) => {
        toast(`Ooops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoading(false);
      });
  };

  const handleSearchForm = (e) => {
    e.preventDefault();
    if (searchProduct !== undefined) {
      navigate(`/search?product=${searchProduct}`);
    } else {
      toast(`Please input any product name`, {
        type: "error",
        position: "top-right",
        autoClose: "1000",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    }
  };

  const handleAddProduct = (e, id, product) => {
    e.preventDefault();

    setLoadingBtn(true);

    const jwt = getJWT();

    const productCart =
      products && products.find((p) => p.productId === product._id);

    if (authState !== undefined) {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: id,
            quantity: ((+productCart && productCart.quantity) || 0) + 1,
          },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((res) => {
          toast(`${product.name} has been added to your cart successfully`, {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          triggerReload();
          closeFavourite();
          setLoadingBtn(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingBtn(false);
        });
    } else {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: id,
            quantity: ((+productCart && productCart.quantity) || 0) + 1,
          },
          { headers: { sessionId: `${getOutletSessionId()}` } }
        )
        .then((res) => {
          toast(`${product.name} has been added to your cart successfully`, {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          triggerReload();
          closeFavourite();
          setLoadingBtn(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          setLoadingBtn(false);
        });
    }
  };

  const handleRemoveFav = (e, id, product) => {
    e.preventDefault();

    const jwt = getJWT();

    setLoadingFav(true);

    axios
      .post(`${ENDPOINT}/products/${id}/unbookmark`, "", {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        toast(
          `${product.name} has been successfully removed from your wishlist`,
          {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          }
        );
        triggerFavouritesReload();
        setLoadingFav(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingFav(false);
      });
  };

  return (
    <div className={`navigation ${props.background}`}>
      {/* <div className='transparent-wrapper'></div> */}
      <Link to="/" className="company-logo">
        <img src={props.logo} alt="The Outlet" />
      </Link>

      <div className="search_form">
        <Form
          flexForm={true}
          formInputData={searchInputData}
          renderForm={(item, index) => renderSearchForm(item, index)}
          buttonContent="Search"
          borderRadius="right"
          handleForm={handleSearchForm}
        />
      </div>

      <Dropdown>
        <Dropdown.Toggle id="liqour_store" className="menu_dropdown">
          Liqour Store
        </Dropdown.Toggle>
        <Dropdown.Menu variant="dark" className="menu_dropdown_wrapper">
          {categories &&
            categories.data &&
            categories.data.map((item) => (
              <Dropdown.Item
                href={`/products?category=${item._id}`}
                key={item.id}
              >
                <Link
                  to={`/products?category=${item._id}&type=${
                    item && item.name
                  }`}
                  className="menuLinks"
                >
                  {item.name}
                </Link>
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown>
        <Dropdown.Toggle id="request_services" className="menu_dropdown">
          Request Services
        </Dropdown.Toggle>

        <Dropdown.Menu variant="dark" className="menu_dropdown_wrapper">
          {services &&
            services.map((service) => (
              <Dropdown.Item
                key={service.id}
                href={`/service?service=${service.id}`}
              >
                <Link
                  to={`/service?service=${service.id}`}
                  className="menuLinks"
                >
                  {service.name}
                </Link>
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
      <span style={{ flex: "1 1 auto" }}></span>

      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          {authState !== undefined && userData !== undefined ? (
            <div className="authentication-btn">
              {userData && userData.data && (
                <DropDown
                  // icon="bx bx-user"
                  customToggle={() => renderUserToggle(userData.data)}
                  contentData={user_menu}
                  renderItems={(item, index) =>
                    renderUserMenu(item, index, handleLogOut)
                  }
                />
              )}
            </div>
          ) : (
            <div className="authentication-btn" onClick={handleShowAuthModal}>
              <i class="bx bx-user"></i>
              <p>Sign In</p>
            </div>
          )}
        </div>

        {/* Favourite List */}
        <div
          className="wish-btn"
          ref={favourite_toggle_ref}
          onClick={() => setActiveFavourite()}
        >
          <i class="bx bx-heart"></i>
        </div>

        {/* Cart */}
        <div
          className="cart-btn"
          ref={menu_toggle_ref}
          onClick={() => setActiveMenu()}
        >
          <i class="bx bx-cart"></i>
          {products && products.length ? (
            <div className="cart-quantity">{products && products.length}</div>
          ) : (
            <></>
          )}
        </div>

        {/* Mobile Menu */}
        <div
          className="mobileMenu_btn"
          ref={mobileMenu_toggle_ref}
          onClick={() => setActiveMobileMenu()}
        >
          <i class="bx bx-menu-alt-right"></i>
        </div>
      </div>

      <Modal
        show={showAuthModal}
        onHide={handleOnCloseAuthModal}
        title={
          authType === "sign-in"
            ? "Sign In"
            : "Sign In" && authType === "sign-up"
            ? "Sign Up"
            : "" && authType === "forgot-password"
            ? "Forgot Password?"
            : ""
        }
        renderBody={
          authType === "sign-in"
            ? renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal,
                submitSignIn,
                loading,
                handleShowPassword
              )
            : renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal
              ) && authType === "sign-up"
            ? renderSignUpModal(
                signUpInputData,
                handleSignInModal,
                submitSignUp,
                loading
              )
            : renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal
              ) && authType === "forgot-password"
            ? renderForgotPasswordModal(
                forgotPasswordInputData,
                handleSignInModal,
                submitForgotPassword,
                loading
              )
            : renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal
              ) && authType === "successful_forgot-password"
            ? renderSuccessfulForgotPasswordSubmitionModal(handleSignInModal)
            : renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal
              ) && authType === "successful_signup"
            ? renderSuccessfulSignUp()
            : renderSignInModal(
                signInInputData,
                handleSignUpModal,
                handleForgotPasswordModal,
                submitSignIn,
                loading
              )
        }
      />

      <div className="favourite_list" ref={favourite_ref}>
        <h4>Saved Items</h4>

        <div className="cart-menu__close" onClick={() => closeFavourite()}>
          <i className="bx bx-x"></i>
        </div>

        <div className="main_favourite_content">
          {favouritesData &&
            favouritesData.map((item) => (
              <Row>
                <Col
                  md={2}
                  sm={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={item.imageUrl} alt="" className="product_image" />
                </Col>
                <Col md={10} sm={12}>
                  <div className="wish_wrapper">
                    <h5>{item.name}</h5>
                    <Button
                      content={loadingBtn ? renderLoadingButton() : "Buy Now"}
                      contentColor="white"
                      onClickHandler={(e) =>
                        handleAddProduct(e, item._id, item)
                      }
                      borderRadius="all"
                      buttonColor="main-bg"
                    />
                  </div>

                  <div className="wish_wrapper">
                    <h4>
                      Ksh {item.price}
                      <small>.00</small>
                    </h4>
                    <p onClick={(e) => handleRemoveFav(e, item._id, item)}>
                      {loadingFav ? (
                        <i class="bx bx-loader"></i>
                      ) : (
                        <i class="bx bxs-trash"></i>
                      )}

                      {loadingFav ? "REMOVING" : "REMOVE"}
                    </p>
                  </div>
                </Col>
              </Row>
            ))}
        </div>
      </div>

      <div className="cart-menu" ref={menu_ref}>
        <h4>Cart</h4>

        <div className="cart-menu__close" onClick={() => closeMenu()}>
          <i className="bx bx-x"></i>
        </div>

        {products && products.length ? (
          <></>
        ) : (
          <h3 style={{ textAlign: "center" }}>Add products to cart</h3>
        )}

        <div className="cart-menu__products">
          {products &&
            products.map((product) => (
              <CartProductCard product={product} key={product._id} />
            ))}
        </div>

        <div className="grandTotal">
          <div>
            <h5>Grand Total: </h5>
            {/* <h6>Ksh {products && products.reduce((productPrice, item) => item.productPrice + productPrice, 0).toLocaleString()}</h6> */}
            <h6>
              Ksh {total.toLocaleString()}.<small>00</small>
            </h6>
          </div>

          {authState !== undefined ? (
            <Button
              action="/order"
              content="Check Out"
              contentColor="white"
              borderRadius="all"
              buttonColor="main-bg"
            />
          ) : (
            <Button
              onClickHandler={() => {
                closeMenu();
                handleShowAuthModal();
              }}
              content="Check Out"
              contentColor="white"
              borderRadius="all"
              buttonColor="main-bg"
            />
          )}
        </div>
      </div>

      <div className="mobileMenu_content" ref={mobileMenu_ref}>
        <div className="mobileMenu_closebtn" onClick={() => closeMobileMenu()}>
          <i className="bx bx-x"></i>
        </div>

        <div className="mobileMenu_logo">
          <img
            src="https://res.cloudinary.com/emacon-production/image/upload/v1638363592/the-outlet/Artboard_7_copy_3png_cyyl9i.png"
            alt="The Outlet"
          />
        </div>

        <div className="mobileSearch_form">
          <Form
            flexForm={true}
            formInputData={searchInputData}
            renderForm={(item, index) => renderSearchForm(item, index)}
            buttonContent="Search"
            borderRadius="all"
            buttonColor="main-bg"
            handleForm={handleSearchForm}
          />
        </div>

        <Link to={`/`} className="Link" onClick={() => closeMobileMenu()}>
          Home
        </Link>

        <div className="mobileMenu_menu">
          <div className="categories">
            <div className="categories_header" onClick={() => setOpenLiqourStore(!openLiquorStore)}>
              <h4>Liqour Store</h4>
              {
                openLiquorStore ? <i class='bx bxs-up-arrow'></i> : <i class='bx bxs-down-arrow'></i>
              }
              
            </div>
            

            {
              openLiquorStore ? (
                <div className="mobileMenu_links">
                  {categories &&
                    categories.data &&
                    categories.data.map((item) => (
                      <Link
                        to={`/products?category=${item._id}&type=${
                          item && item.name
                        }`}
                        className="Link"
                        onClick={() => {
                          closeMobileMenu();
                          setOpenLiqourStore(false);
                        }}
                      >
                        {item.name}
                      </Link>
                    ))}
                </div>
              ) : <></>
            }

          </div>

          <div className="services">
            <div className="services_header"onClick={() => setOpenServices(!openServices)} >
              <h4>Request For Service</h4>
              {
                openServices ? <i class='bx bxs-up-arrow'></i> : <i class='bx bxs-down-arrow'></i>
              }
            </div>
            

            {
              openServices ? (
                <div className="mobileMenu_links">
                  {services &&
                    services.map((service) => (
                      <Link
                        to={`/service?service=${service.id}`}
                        className="Link"
                        onClick={() => {
                          closeMobileMenu();
                          setOpenServices(false);
                        }}
                      >
                        {service.name}
                      </Link>
                    ))}
                </div>
              ) : <></>
              
            }

          </div>

          {authState !== undefined ? (
            <div className="authenticated_userMobileMenu">
              <h4>{userData && userData.data && userData.data.email}</h4>

              {user_menu.map((item, index) => (
                <Link
                  key={index}
                  to={item.targetLink}
                  className="Link"
                  onClick={item.content === "Logout" ? handleLogOut : ""}
                >
                  <i
                    className={item.icon}
                    style={{ paddingRight: "0rem", fontSize: "1rem" }}
                  ></i>
                  <span style={{ paddingLeft: "1rem" }}>{item.content}</span>
                </Link>
              ))}
            </div>
          ) : (
            <div
              className="mobileAuthentication-btn"
              onClick={() => {
                handleShowAuthModal();
                closeMobileMenu();
              }}
            >
              <i class="bx bx-user"></i>
              <p>Sign In</p>
            </div>
          )}
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Navigation;
